module.exports = __webpack_public_path__ + "static/img/SE.b2bff56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/countries/SE.svg
// module id = 939
// module chunks = 0